/**
 * Contenteditable Utilities
 * @namespace ContentUtils
 */

export default class ContentUtils {

    /**
     * Get contenteditable text 
     * @param {HTMLElement} element - Contenteditable element
     * @param {Function} callback
     */
    static getContentEditableText(element, callback = () => {}) {
        console.log('elementelement', element)

        const text = element.innerText;
        callback(text || '');
    }

    /**
     * Set contenteditable text
     * @param {HTMLElement} element - Contenteditable element
     * @param {string} text - Text to set
     * @param {Function} callback
     * 
     */
    static setContentEditableText(element, text, callback = () => {}) {
        if (element) {
            element.innerText = text;
            callback(text);
        }
    }

}